import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-congratulations",
  templateUrl: "./congratulations.component.html",
  styleUrls: ["./congratulations.component.css"]
})
export class CongratulationsComponent implements OnInit {

  constructor(public modalRef: BsModalRef, private router: Router) { }

  ngOnInit(): void {
  }

  exploreMoreJobs() {
    this.modalRef.hide();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["dashboard-job"]);
  }
}
